import { Empty } from 'antd';
import React from 'react';

export const EmptyComponentWithDataTestId: React.FC = () => {
  return <Empty description={<span data-testid="no-data">Нет данных</span>} />;
};
